import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { mapGptEventAlarmsGeoJsonState } from '../../../storage/gpt';
import GptEventAlarmMarker from './GptEventAlarmMarker';

function GptEventAlarmsMarkers() {
  const geojson = useRecoilValue(mapGptEventAlarmsGeoJsonState);

  return (
    <>
      {geojson.map((feature, index) => {
        const { properties } = feature;
        const alarm = properties?.alarm;
        if (alarm) {
          return <GptEventAlarmMarker key={index} alarm={alarm} />;
        }
        return null;
      })}
    </>
  );
}

export default memo(GptEventAlarmsMarkers);
